import { AbstractNpiSource } from './abstract-npi.source';
import { ApiClient } from '../../../api';
import { NpiSourceEnum, ProcessNpiBodyDto } from '../../../dto/recs.dto';
import { AdSet } from '../../../entities/ad-set';
import { Injectable, Optional } from '../../dependency-injection/decorators';
import { HttpClient } from '../../http-client/http-client';
import { Logger } from '../../logger/logger';

@Injectable()
export class LhkNpiSource extends AbstractNpiSource {
  public constructor (
    apiClient: ApiClient,
    private readonly httpClient: HttpClient,
    @Optional() private readonly logger?: Logger,
  ) {
    super(apiClient);
  }

  getType (): NpiSourceEnum {
    return NpiSourceEnum.LHK;
  }

  protected async process (adSet: AdSet): Promise<ProcessNpiBodyDto> {
    const npiDetectorUrl = adSet.getSettings().getNpiDetectors()?.[ this.getType() ]?.url;

    if (!npiDetectorUrl) {
      return {
        encryptedNpi: undefined,
        aimId: undefined,
        source: this.getType(),
      };
    }

    try {
      const url = new URL(npiDetectorUrl);
      url.searchParams.set('test', 'true');

      const request = this.httpClient.createRequest('GET', url);
      request.withHeader('X-Session-Id', 'test');

      const response = await this.httpClient.sendRequest(request, 'include');

      const result = await response.json<{ encrypted: string | false }>();

      return {
        source: this.getType(),
        encryptedNpi: result.encrypted ? result.encrypted : undefined,
      };
    } catch (e) {
      this.logger?.error(e);

      return {
        encryptedNpi: undefined,
        aimId: undefined,
        source: this.getType(),
      };
    }
  }
}
